/*
 *
 * PartnerPage actions
 *
 */

const SCOPE = 'app/PartnerPage/';
export const ActionTypes = {
    SET_PARAMS: `${SCOPE}SET_PARAMS`,
    SET_IS_404: `${SCOPE}SET_IS_404`,

    SET_PAGE_IS_LOADED: `${SCOPE}SET_PAGE_IS_LOADED`,
    RESET_PAGE: `${SCOPE}RESET_PAGE`,
    FETCH_PAGE: `${SCOPE}FETCH_PAGE`,
    FETCH_PAGE_STARTED: `${SCOPE}FETCH_PAGE_STARTED`,
    FETCH_PAGE_SUCCESSFULLY: `${SCOPE}FETCH_PAGE_SUCCESSFULLY`,
    FETCH_PAGE_FAILED: `${SCOPE}FETCH_PAGE_FAILED`,
    FETCH_PAGE_CANCELLED: `${SCOPE}FETCH_PAGE_CANCELLED`,

    SET_ACTIVITIES_IS_LOADED: `${SCOPE}SET_ACTIVITIES_IS_LOADED`,
    SET_ACTIVITIES_HAS_MORE: `${SCOPE}SET_ACTIVITIES_HAS_MORE`,
    RESET_ACTIVITIES: `${SCOPE}RESET_ACTIVITIES`,
    FETCH_ACTIVITIES: `${SCOPE}FETCH_ACTIVITIES`,
    FETCH_ACTIVITIES_STARTED: `${SCOPE}FETCH_ACTIVITIES_STARTED`,
    FETCH_ACTIVITIES_SUCCESSFULLY: `${SCOPE}FETCH_ACTIVITIES_SUCCESSFULLY`,
    FETCH_ACTIVITIES_FAILED: `${SCOPE}FETCH_ACTIVITIES_FAILED`,
    FETCH_ACTIVITIES_CANCELLED: `${SCOPE}FETCH_ACTIVITIES_CANCELLED`,

    SET_RECOMMENDS_IS_LOADED: `${SCOPE}SET_RECOMMENDS_IS_LOADED`,
    FETCH_RECOMMENDS: `${SCOPE}FETCH_RECOMMENDS`,
    FETCH_RECOMMENDS_STARTED: `${SCOPE}FETCH_RECOMMENDS_STARTED`,
    FETCH_RECOMMENDS_SUCCESSFULLY: `${SCOPE}FETCH_RECOMMENDS_SUCCESSFULLY`,
    FETCH_RECOMMENDS_FAILED: `${SCOPE}FETCH_RECOMMENDS_FAILED`,
    FETCH_RECOMMENDS_CANCELLED: `${SCOPE}FETCH_RECOMMENDS_CANCELLED`,

    SET_USER_IMAGES_IS_LOADED: `${SCOPE}SET_USER_IMAGES_IS_LOADED`,
    FETCH_USER_IMAGES_STARTED: `${SCOPE}FETCH_USER_IMAGES_STARTED`,
    FETCH_USER_IMAGES_SUCCESSFULLY: `${SCOPE}FETCH_USER_IMAGES_SUCCESSFULLY`,
    FETCH_USER_IMAGES_FAILED: `${SCOPE}FETCH_USER_IMAGES_FAILED`,
    FETCH_USER_IMAGES_CANCELLED: `${SCOPE}FETCH_USER_IMAGES_CANCELLED`,
};

/**
 * Common
 */
export const setIs404 = (is404) => ({
    type: ActionTypes.SET_IS_404,
    is404,
});

export const setParams = (params) => ({
    type: ActionTypes.SET_PARAMS,
    params,
});

/**
 * Page
 */
export const setPageIsLoaded = (isLoaded) => ({ type: ActionTypes.SET_PAGE_IS_LOADED, isLoaded });
export const fetchPage = () => ({ type: ActionTypes.FETCH_PAGE });
export const resetPage = () => ({ type: ActionTypes.RESET_PAGE });
export const fetchPageStarted = () => ({ type: ActionTypes.FETCH_PAGE_STARTED });
export const fetchPageSuccessfully = (res) => ({
    type: ActionTypes.FETCH_PAGE_SUCCESSFULLY,
    res,
});
export const fetchPageFailed = (error) => ({
    type: ActionTypes.FETCH_PAGE_FAILED,
    error,
});
export const fetchPageCancelled = () => ({
    type: ActionTypes.FETCH_PAGE_CANCELLED,
});

/**
 * Activities
 */
export const setActivitiesIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_ACTIVITIES_IS_LOADED,
    isLoaded,
});
export const setActivitiesHasMore = (hasMore) => ({
    type: ActionTypes.SET_ACTIVITIES_HAS_MORE,
    hasMore,
});
export const fetchActivities = () => ({ type: ActionTypes.FETCH_ACTIVITIES });
export const resetActivities = () => ({ type: ActionTypes.RESET_ACTIVITIES });
export const fetchActivitiesStarted = () => ({ type: ActionTypes.FETCH_ACTIVITIES_STARTED });
export const fetchActivitiesSuccessfully = (res) => ({
    type: ActionTypes.FETCH_ACTIVITIES_SUCCESSFULLY,
    res,
});
export const fetchActivitiesFailed = (error) => ({
    type: ActionTypes.FETCH_ACTIVITIES_FAILED,
    error,
});
export const fetchActivitiesCancelled = () => ({
    type: ActionTypes.FETCH_ACTIVITIES_CANCELLED,
});

/**
 * Recommends
 */
export const setRecommendsIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_RECOMMENDS_IS_LOADED,
    isLoaded,
});
export const fetchRecommends = () => ({ type: ActionTypes.FETCH_RECOMMENDS });
export const fetchRecommendsStarted = () => ({ type: ActionTypes.FETCH_RECOMMENDS_STARTED });
export const fetchRecommendsSuccessfully = (res) => ({
    type: ActionTypes.FETCH_RECOMMENDS_SUCCESSFULLY,
    res,
});
export const fetchRecommendsFailed = (error) => ({
    type: ActionTypes.FETCH_RECOMMENDS_FAILED,
    error,
});
export const fetchRecommendsCancelled = () => ({
    type: ActionTypes.FETCH_RECOMMENDS_CANCELLED,
});

/**
 * UserImages
 */
export const setUserImagesIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_USER_IMAGES_IS_LOADED,
    isLoaded,
});
export const fetchUserImagesStarted = () => ({ type: ActionTypes.FETCH_USER_IMAGES_STARTED });
export const fetchUserImagesSuccessfully = (res) => ({
    type: ActionTypes.FETCH_USER_IMAGES_SUCCESSFULLY,
    res,
});
export const fetchUserImagesFailed = (error) => ({
    type: ActionTypes.FETCH_USER_IMAGES_FAILED,
    error,
});
export const fetchUserImagesCancelled = () => ({
    type: ActionTypes.FETCH_USER_IMAGES_CANCELLED,
});
